export class OfferFilterSettingsModel {
  public timePeriodId?: number;
  public startDate?: string;
  public endDate?: string;
  public city: string;
  public price: number;
  public boilerMake: string;
  public traderName: string;
  public regionId: number;
  public statusId: number;
  public systemTraderId: number;
  public systemManagerRegionId: number;
}